import { Component, OnInit, Input } from '@angular/core';
import * as moment from 'moment';
import { EntityDirectoryService } from '../../entity-directory.service';
import { SessionService } from '../../../../services';
import { FormattedTransaction } from '../../../../models';

@Component({
  selector: 'entity-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss']
})
export class EntityTransactionsComponent implements OnInit {
  // Is passed to the dashboard component to trigger ngOnChanges.
  @Input() active;

  // Columns that are used in the transactions table.
  columns = {
    identifier: 'Transaction ID',
    sourceEntity: 'Source Entity',
    destinationEntity: 'Destination Entity',
    transferDate: 'Transfer Date',
    units: 'Units',
    value: 'Value',
    transactionTypeName: 'Transaction Type',
    propertyTransferred: 'Property Transferred'
  };

  formattedTransactions: FormattedTransaction[] = [];

  constructor(
    private service: EntityDirectoryService,
    private sessionService: SessionService
  ) { }

  ngOnInit() {
    this.columns.value = `Value (${this.sessionService.getContainerUpeCurrency().isoCode})`;
    this.getTransactions();
  }

  /**
   * Gets the first destination entity in the trade parties.
   * @param parties
   */
  getDestinationEntity(parties) {
    return parties.find(({ isSource }) => !isSource).entity.name;
  }

  /**
   * Formats the number into a comma delimited number (e.g. 123,456,789).
   * @param parties
   */
  getUnitNumber(unit) {
    if (isNaN(parseInt(unit, 10))) {
      return 0;
    }
    return parseInt(unit, 10).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  /**
   * Formats the number into a comma delimited number (e.g. 123,456,789).
   * @param parties
   */
  getValueNumber(unit) {
    if (isNaN(parseInt(unit, 10))) {
      return 0;
    }
    return parseFloat(unit).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  /**
   * Gets the first source entity in the trade parties.
   * @param parties
   */
  getSourceEntity(parties) {
    return parties.find(({ isSource }) => !!isSource).entity.name;
  }

  /**
   * Pull in service transactions data object and ready it for the datatable.
   */
  getTransactions() {
    this.service.getTransactions().subscribe((transactions) => {
      this.formattedTransactions = transactions.data.map((trans) => {
        return {
          identifier: trans.identifier,
          sourceEntity: this.getSourceEntity(trans.legalEntityTransactions),
          destinationEntity: this.getDestinationEntity(trans.legalEntityTransactions),
          transferDate: this.getTransferDate(trans),
          units: this.getUnitNumber(trans.units),
          value: this.getValueNumber(trans.value),
          transactionTypeName: trans.transactionType.name,
          propertyTransferred: trans.propertyTransferred
        };
      });
    });
  }

  /**
   * Transform the date to be an ideal of `d MMM YYYY`.
   * @param {Object} ... The object with the day, month, year as corresponding
   * with the service API call.
   */
  getTransferDate({ transferDateDay, transferDateMonth, transferDateYear }) {
    const date = new Date();
    if (transferDateYear) {
      date.setFullYear(transferDateYear);
    }
    if (transferDateMonth) {
      date.setMonth(transferDateMonth - 1);
    } else {
      return moment(date).format('YYYY');
    }
    if (transferDateDay) {
      date.setDate(transferDateDay);
    } else {
      return moment(date).format('MMM YYYY');
    }
    return moment(date).format('D MMM YYYY');
  }
}
